export type YandexSyncResponse = {
  created: number;
  updated: number;
  missing: number;
};

function readCount(value: unknown): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? Math.trunc(parsed) : 0;
}

export function normalizeYandexSyncResponse(raw: unknown): YandexSyncResponse {
  if (!raw || typeof raw !== "object") {
    return { created: 0, updated: 0, missing: 0 };
  }

  const item = raw as Record<string, unknown>;
  return {
    created: readCount(item.created),
    updated: readCount(item.updated),
    missing: readCount(item.missing),
  };
}
